export default "__VITE_ASSET__ClnYhIaP__"